import axios from 'axios'
import { ref } from 'vue'

import { baseUrl } from '@/../app.config'
import { applyInstanceTheme } from '@/utils/instanceTheme'

const CONFIG_URL = `${baseUrl}instance-config.json`
const CONTENT_URL = `${baseUrl}instance-content.html`

const config = ref(null)
const content = ref(null)
const isLoading = ref(true)
const error = ref(null)

let fetched = false

function fetchOnce() {
  if (fetched) return
  fetched = true
  Promise.allSettled([axios.get(CONFIG_URL), axios.get(CONTENT_URL)])
    .then(([configResult, contentResult]) => {
      if (configResult.status === 'fulfilled') {
        config.value = configResult.value.data
        applyInstanceTheme(config.value.theme)
      } else {
        error.value = configResult.reason
        console.warn(
          '[useInstanceData] failed to load instance-config.json',
          configResult.reason,
        )
      }
      if (contentResult.status === 'fulfilled') {
        content.value = contentResult.value.data
      } else {
        console.warn(
          '[useInstanceData] failed to load instance-content.html',
          contentResult.reason,
        )
      }
    })
    .finally(() => {
      isLoading.value = false
    })
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    fetched = false
    config.value = null
    content.value = null
    isLoading.value = true
    error.value = null
  })
}

export function useInstanceData() {
  fetchOnce()
  return { config, content, isLoading, error }
}
